import { Component } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import '../../css/styles.css';

@Component({
  selector: 'my-app',
  template: require('./app.component.html')
})

export class AppComponent {

  constructor(translate: TranslateService) {
    console.log("APP COMPONENT");
    var language = localStorage.getItem("language");
    var hostname = location.host;
    if (language != "" && language != "null" && language != "undefined" && language != null && language != undefined) {
      translate.setDefaultLang(language);
      translate.use(language);
    } else {
      if (hostname == "www.mercatambulant.cat" || hostname == "mercatambulant.cat") {
        translate.setDefaultLang('cat');
        translate.use('cat');
      } else if (hostname == "www.mercadilloambulante.com" || hostname == "mercadilloambulante.com") {
        translate.setDefaultLang('esp');
        translate.use('esp');
      } else {
        translate.setDefaultLang('esp');
        translate.use('esp');
        console.log(hostname);
      }
    }
  }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/